/** Analytics accounts are opt-in deployment configuration; there are no shared accounts. */
function configuredId(
  value: string | undefined,
  format: RegExp
): string | undefined {
  return value && format.test(value) ? value : undefined;
}

export const GOOGLE_ANALYTICS_ID = configuredId(
  import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
  /^G-[A-Z0-9]+$/
);
export const GOOGLE_TAG_MANAGER_ID = configuredId(
  import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID,
  /^GTM-[A-Z0-9]+$/
);
export const META_PIXEL_ID = configuredId(
  import.meta.env.VITE_META_PIXEL_ID,
  /^\d+$/
);
export const GOOGLE_ADS_ID = configuredId(
  import.meta.env.VITE_GOOGLE_ADS_ID,
  /^AW-\d+$/
);

/** Development disables analytics; missing deployment values also prevent SDK startup. */
export function canInitializePosthog(): boolean {
  return (
    import.meta.env.DEV !== true &&
    !!(
      import.meta.env.VITE_POSTHOG_API_KEY && import.meta.env.VITE_POSTHOG_HOST
    )
  );
}
